
export const get_data_customTable = async (customTable) => {
    let obj = {};
    let array = [];
    try {
        // se debe consultar por el nombre para encontrar el id
        const resId = await axios.get(`/admin/app/custom-table/serverside/id/${customTable}`);
        if (resId.data.id) {
            const response = await axios.get(`/admin/app/custom-table/values/${resId.data.id}`);
            const dataRes = response.data.data;
            for (let index = 0; index < dataRes.length; index++) {
                const element = dataRes[index]['field_values'];
                for (let y = 0; y < element.length; y++) {
                    if (y == 0) {
                        obj = {'id' : element[y]['id'], 'value' : element[y]['value']};
                        array.push(obj);
                    }
                }
            }
            return array;
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export const get_data_contract = async (id) => {
    let datos = [];
    let optContract = [
        'Not Approved', 'Approve', 'Pending Approval'
    ];
    try {
        const response = await axios.get(`/contracts/get_contract_details/${id}`); // <- aca la data del contrato
        const data = response.data;
        if (data.length > 0) {
            const res = data[0];
            let objMaster = {
                "category"      : {
                    "category"  : res.category?.category ?? null,
                    "code"      : res.category?.code ?? null,
                    'id'        : res.category?.id ?? null,
                    'name'      : res.category?.name ?? null,
                },
                "contractNumber" : res?.number ?? null,
                "country"       : {
                    "Code"      :res.country.Code,
                    "id"        :res.country.id,
                    "name"      :res.country.name,
                }
            }
            datos.push(objMaster);

            let arrayCheck = [];
            if (res.check_label_approved) { arrayCheck.push("Fruitrade's Label Approved"); }
            if (res.check_specifications_sent) { arrayCheck.push('Specifications Sent'); }
            if (res.check_customer_po) { arrayCheck.push('Customer PO'); }
            if (res.check_compilance) { arrayCheck.push('Compliance Package'); }
            if (res.check_purchases_confirmation) { arrayCheck.push('Purchase confirmation sent'); }
            if (res.check_sales_confirmation) { arrayCheck.push('Sales confirmation sent'); }
            if (res.check_quality_inspection) { arrayCheck.push('Quality Inspection Required?'); }

            console.log({res});
            
            // tener en cuenta que las custom table siempre tiene la estructura id, value
            let obj = {
                "cd_contract_id"                : id,
                "status"                        : {id:res.status_id, value:res.status}, // status custom table
                "fiscal_year"                   : {id:res.fiscal_year_id, value:res.fiscal_year}, // fiscal year custom table
                "load_type"                     : {id:res.load_type_id, value:res.load_type}, // load type custom table
                "product_type"                  : {id:res.product_type.id, name:res.product_type.name}, // product type custom table
                "salesCoord"                    : {id:res.sales_coord.id, full_name:(res.sales_coord.first_name + ' ' + res.sales_coord.last_name)},
                "logisticCoord"                 : {id:res.logistic_user.id, full_name:(res.logistic_user.first_name + ' ' + res.logistic_user.last_name)},
                "shipment_type"                 : {id:res.shipment_type_id, value:res.shipment_type}, // shipment type custom table
                "loads"                         : res.loads, // input normal
                "loads_completed"               : res.loads_completed, // input normal
                "tem_celsius"                   : res.tem_celsius, // input normal
                "load_method"                   : {id:res.load_method_id, value:res.load_method}, // shipment type custom table
                "approve_contract"              : {id: res.approve_contract, value:optContract[res.approve_contract]},
                "checkbox"                      : arrayCheck, // arrays de los checks
                "additional_info"               : res.additional_info,
            }
            datos.push(obj);
            return datos;
        }
    } catch (error) {
        console.error('Error fetching contract:', error);
        return false;
    }
}

export const get_tariff = async (from, destination, product, subcategory_id) => {
    let obj = {};
    try {
        const response = await axios.get(
          `/contracts/serverside/tariff/${from}/${destination}/${product}/${subcategory_id}`
        );
        const tariff = response.data.tariff;
        if (typeof tariff != "undefined") {
          obj.tariff = tariff + "%";
        }
        const duty = response.data.duty_rate;
        if (typeof duty != "undefined") {
          let duty_rate = duty * 100;
          obj.duty = duty_rate + "%";
        }
        const duty_number = response.data.duty_number;
        if (typeof duty_number != "undefined") {
          obj.duty_number = duty_number;
        }
        const hts_code = response.data.hts_code;
        if (typeof hts_code != 'undefined') {
            obj.hts_code = hts_code;
        }
    } catch (error) {
        console.error("Error fetching tariff value:", error);
    }
    return obj;
}

export const get_data_products = async (id) =>{
    if (id) {
        try {
            const response = await axios.get( `/contracts/get_contract_products/${id}` ); // <- aca la data del contrato
            const data = response.data;
            if (data.length > 0) {
                const res = data;
                let productArray = [];
                let index = 1;
                for (const item of res) {
                    let obj = {
                        pd_unique_id : "" + item.Product_id + index,
                        pd_contrac_product_id: item.ID,
                        pd_country_destination: {
                            id: item.destination_country?.id ?? null,
                            name: item.destination_country?.name ?? null,
                            Code: item.destination_country?.Code ?? null,
                        },
                        pd_crop: { id: item.Crope_id, value: item.Crope },
                        pd_item: { id: item.Item_id, value: item.Item },
                        pd_subCategory: {
                            id: item.subcategory_id,
                            value: item.subcategory_value,
                        },
                        pd_product: {
                            id: item.Product_id,
                            name: item.ProductName,
                            category: null,
                        },
                        pd_variety : {
                            id : item.product_variety_id,
                            value : item.product_variety_value,
                        },
                        pd_feature: {
                            id: item.Product_Feature_id,
                            value: item.Product_Feature_value,
                        },
                        pd_cut_size: {
                            id: item.Product_Cut_Size_id,
                            value: item.Product_Cut_Size_value,
                        },
                        pd_grade: { id: item.Grade_id, value: item.Grade_name },
                        pd_typedata: {
                            id: item.OrganicConv_id,
                            value: item.OrganicConv,
                        },
                        pd_quantity: parseFloat(item.QuantityUnit).toLocaleString('es-ES', { maximumFractionDigits: 0 }),
                        pd_pack: { id: item.Packaging_Type_id, value: item.Packaging },
                        pd_weight: item.Weight,
                        pd_net: { id: item.TotalWNetLb_id, code: item.TotalWNetLb },
                        pd_supplierCurrency: {
                            id: item.currency_supplier?.Id ?? null,
                            Code: item.currency_supplier?.Code ?? null,
                        },
                        pd_suplierPrice: item.SuppPriceAmount ? Number(item.SuppPriceAmount) : null,
                        pd_supplierUnit: {
                            id: item.supplier_Unit_of_measure_id,
                            code: item.supplier_Unit_of_measure,
                            factor: item.supplier_Unit_of_measure_factor,
                        },
                        pd_customerCurrency: {
                            id: item.currency_customer?.Id ?? null,
                            Code: item.currency_customer?.Code ?? null,
                        },
                        pd_customerPrice: item.CustPriceAmount,
                        pd_customerUnit: {
                            id: item.customer_unit_of_measure_id,
                            code: item.customer_unit_of_measure,
                            factor : item.customer_Unit_of_measure_factor,
                        },
                        pd_tariff: item.Tariff,
                        pd_duty: item.DutyRate,
                        pd_hts_code : item.hts_code,
                        pd_loads: item.LoadsPerProduct,
                        pd_note: item.AdditionalInfo,
                        pd_quantity_detail: item.quantity_detail,
                        supplier_price_detail : item.supplier_price_detail,
                        supplier_qty_detail : item.supplier_qty_detail,
                        customer_price_detail : item.customer_price_detail,
                        customer_qty_detail : item.customer_qty_detail,
                        supplier_additional_fees : item.supplier_additional_fees,
                        supplier_additional_fees_comment: item.supplier_additional_fees_comment,
                        customer_additional_fees : item.customer_additional_fees,
                        customer_additional_fees_comment : item.customer_additional_fees_comment,
                    };
                    productArray.push(obj);
                    index ++;
                }
                return productArray;
            }
        } catch (error) {
            console.error("Error fetching contract:", error);
        }
    }
}

export const get_ship_address = async (supplierId) => {
    try {
        const response = await axios.get(`/companies_supplier/serverside/ship_address/2/${supplierId}`);
        return response.data.data;
   } catch (error) {
        console.error('Error al obtener los detalles del proveedor:', error);
   }
}

export const get_ship_address_customer = async (id) => {
    try {
        const response = await axios.get(`/companies_customer/serverside/ship_address/${id}`);
        return response.data.data;
   } catch (error) {
        console.error('Error al obtener los detalles del proveedor:', error);
   }
}

export const get_data_supplier = async (id) => {
    try {
        const response = await axios.get(`/contracts/get_contract_supplier/${id}`); // <- aca la data del supplier
        const data = response.data;
        if (data.length > 0) { // Aca se llena el local storage del edit, no los inputs directamente, ya la logica de abajo hace esa parte
            const res = data[0]; 
            let ship = 0;
            if(res.Ship_address_id) ship++;
            if(res.Ship_address_id_2) ship++;
            if(res.Ship_address_id_3) ship++;
            if(res.Ship_address_id_4) ship++;
            let obj = {
                "sd_selectedOption": ship,
                "sd_supplier": {
                    "id":               res.supplier_company.id,
                    "Title":            res.supplier_company.Second_Title,
                    "BillAddress":      res.supplier_company.BillAddress,
                    "cityName":         res?.bill_city?.name ?? '',
                    "stateName":        res?.bill_state?.name ?? '',
                    "countryName":      res?.bill_country?.name ?? '',
                    "PostalZipCode":    res.supplier_company.PostalZipCode,
                    "titulo" :           res.supplier_company.Second_Title
                },
                "sd_packer": {
                    "id":       res.packer_company_id,
                    "value":    res.packer_company_name,
                },
                "sd_broker": {
                    "id":       res.broker_company_id,
                    "value":    res.broker_name
                },
                "sd_ship":                      {"id": res.ShipFromTo_id, "value": res.ShipFromTo },
                "sd_descriptionSupplier":       formattedCompanySupplier(res),
                "sd_formatteDate":              res.StartDate,
                "sd_payment_term":              {"id": res.payment_term_id, "value": res.payment_term },
                "sd_incoterm":                  {"id": res.Incoterm_id, "value": res.Incoterm },
                "sd_incoterm_2":                {"id": res.Incoterm_id_2, "value": res.Incoterm_2 },
                "sd_incoterm_3":                {"id": res.Incoterm_id_3, "value": res.Incoterm_3 },
                "sd_incoterm_4":                {"id": res.Incoterm_id_4, "value": res.Incoterm_4 },
                "sd_finalDestination":          {"id" : res.FinalDestination_id, "value" : res.FinalDestination},
                "sd_specialDiscount":           res.SpecialConditions,
                "sd_packer_name":               null,
                "sd_end_date":                  res.EndDate,
                "sd_label_selected":            res.supplier_label_id,
                "sd_label":                     {"id": res.supplier_label_id, "value": res.supplier_label_name},
                "sd_finalDest":                 res.ShipFinalDest ? {"id" : 1, "value" : res.ShipFinalDest} : null,
                "sd_additionalShipmentDetail":  res.AdditionalSD,
                "sd_commision":                 res.Commission,
                "sd_selected_ship_address":     res.Ship_address_id,
                "sd_ship_address": {
                    "id":               res?.ship_address?.id ?? null,
                    "name":             res?.ship_address?.name ?? '',
                    'address':          res?.ship_address?.address ?? '',
                    "city_name":        res?.ship_city?.name ?? '',
                    "state_name":       res?.ship_state?.name ?? '',
                    "country_name":     res?.ship_country?.name ?? '',
                    "zipCode":          res?.ship_address?.postal_zip_code ?? '',
                },
                "sd_ship_address_2": {
                    "id":               res.ship_address2?.id,
                    "name":             res.ship_address2?.name,
                    'address':          res?.ship_address2?.address ?? '',
                    "city_name":        res.ship_city2?.name,
                    "state_name":       res.ship_state2?.name,
                    "country_name":     res.ship_country2?.name,
                    "zipCode":          res.ship_address2?.postal_zip_code,
                },                
                "sd_ship_address_3": {
                    "id":               res.ship_address3?.id,
                    "name":             res.ship_address3?.name,
                    'address':          res?.ship_address3?.address ?? '',
                    "city_name":        res.ship_city3?.name,
                    "state_name":       res.ship_state3?.name,
                    "country_name":     res.ship_country3?.name,
                    "zipCode":          res.ship_address3?.postal_zip_code,
                },
                "sd_ship_address_4": {
                    "id":               res.ship_address4?.id,
                    "name":             res.ship_address4?.name,
                    'address':          res?.ship_address4?.address ?? '',
                    "city_name":        res.ship_city4?.name,
                    "state_name":       res.ship_state4?.name,
                    "country_name":     res.ship_country4?.name,
                    "zipCode":          res.ship_address4?.postal_zip_code,
                },
                "sd_supplier_condition" : {"id" : res.contract_condition?.id ?? null, "value":res.contract_condition?.name ?? null},
                "label_description" : res.label_description,
            }
            console.log({obj});
            
            return obj;
        }
    } catch (error) {
        console.error('Error fetching contract:', error);
    }
}

const formattedCompanySupplier = (ship) => {
    let linesWithBreaks = [];

    if (ship?.supplier_company?.Second_Title) {
        linesWithBreaks.push(ship.supplier_company?.Second_Title + ',' );
    }

    if (ship?.supplier_company?.BillAddress) {
        linesWithBreaks.push(ship.supplier_company.BillAddress + ',');
    }

    if (ship?.bill_city?.name) {
        linesWithBreaks.push(ship.bill_city.name + ',');
    }

    let stateCountryLine = [];
    if (ship?.bill_state?.name) {
        stateCountryLine.push(ship.bill_state.name + ', ');
    }

    if (ship?.bill_country?.name) {
        stateCountryLine.push(ship.bill_country.name + ', ');
    }

    if (ship?.supplier_company?.PostalZipCode) {
        stateCountryLine.push(ship.supplier_company.PostalZipCode);
    }

    if (stateCountryLine.length > 0) {
        linesWithBreaks.push(stateCountryLine.join(' '));
    }
    return linesWithBreaks;
}

export const get_data_customer = async (id) => {
    try {
        const response = await axios.get(`/contracts/get_contract_customer/${id}`); // <- aca la data del supplier
        const data = response.data;
        if (data.length > 0) { // Aca se llena el local storage del edit, no los inputs directamente, ya la logica de abajo hace esa parte
            const res = data[0];
            let ship = 0;
            if(res.Ship_address_id_1) ship++;
            if(res.Ship_address_id_2) ship++;
            if(res.Ship_address_id_3) ship++;
            if(res.Ship_address_id_4) ship++;
            let obj = {
                "cud_selectedOption": ship,
                "cud_customer": {
                    "id":           res.customer_company.id,
                    "Title":        res.customer_company.Second_Title,
                    "BillAddress":  res.customer_company.BillAddress,
                    "cityName":     res.bill_city.name,
                    "stateName":    res.bill_state.name,
                    "countryName":  res.bill_country.name,
                    "PostalZipCode" : res.customer_company.PostalZipCode,
                    "titulo"        : res.customer_company.Second_Title
                },
                "cud_descriptionCustomer": `${res.customer_company.Second_Title}  ${res.customer_company.BillAddress} \n ${res.bill_city.name}, ${res.bill_state.name}, ${res.bill_country.name}, ${res.customer_company.PostalZipCode}`,
                "cud_selected_ship_address_1": {
                    "id":               res.ship_address1?.id ?? null,
                    "name":             res.ship_address1?.name ?? '',
                    "address" :         res.ship_address1?.address ?? '',
                    "city_name":        res.ship_city1?.name ?? '',
                    "state_name":       res.ship_state1?.name ?? '',
                    "country_name":     res.ship_country1?.name ?? '',
                    "zipCode":          res.ship_address1?.postal_zip_code ?? '',
                },

                "cud_selected_ship_address_2": {
                    "id":               res.ship_address2?.id,
                    "name":             res.ship_address2?.name ?? '',
                    "address" :         res.ship_address2?.address ?? '',
                    "city_name":        res.ship_city2?.name,
                    "state_name":       res.ship_state2?.name,
                    "country_name":     res.ship_country2?.name,
                    "zipCode":          res.ship_address2?.postal_zip_code,
                },

                "cud_selected_ship_address_3": {
                    "id":               res.ship_address3?.id,
                    "name":             res.ship_address3?.name ?? '',
                    "address" :         res.ship_address3?.address ?? '',
                    "city_name":        res.ship_city3?.name,
                    "state_name":       res.ship_state3?.name,
                    "country_name":     res.ship_country3?.name,
                    "zipCode":          res.ship_address3?.postal_zip_code,
                },

                "cud_selected_ship_address_4": {
                    "id":               res.ship_address4?.id,
                    "name":             res.ship_address4?.name ?? '',
                    "address" :         res.ship_address4?.address ?? '',
                    "city_name":        res.ship_city4?.name,
                    "state_name":       res.ship_state4?.name,
                    "country_name":     res.ship_country4?.name,
                    "zipCode":          res.ship_address4?.postal_zip_code,
                },

                "cud_ship_selected": res.CustShipToFrom_id,
                "cud_ship": {
                    "id":       res.CustShipToFrom_id,
                    "value":    res.CustShipToFrom,
                },
                "cud_incoterm_selected": res.incoterm_id,
                "cud_incoterm": {
                    "id":     res.incoterm_id,
                    "value":  res.incoterm,
                },
                "cud_incoterm_selected_2": res.Incoterm_id_2,
                "cud_incoterm_2": {
                    "id":     res.Incoterm_id_2,
                    "value":  res.Incoterm_2,
                },
                "cud_incoterm_selected_3": res.Incoterm_id_3,
                "cud_incoterm_3": {
                    "id":     res.Incoterm_id_3,
                    "value":  res.Incoterm_3,
                },
                "cud_incoterm_selected_4": res.Incoterm_id_4,
                "cud_incoterm_4": {
                    "id":     res.Incoterm_id_4,
                    "value":  res.Incoterm_4,
                },
                "cud_pay_term_selected": res.payment_term_id,
                "cud_pay_term": {
                    "id":       res.payment_term_id,
                    "value":    res.payment_term,
                },
                "cud_end_date": res.EndDate,
                "cud_customer_cond": res.customer_condition,
                "cud_broker": {
                    "id":       res.broker_company_id,
                    "value":    res.broker_name,
                },
                "cud_finalDest" : {id : res.FinalDestination_id, address : res.FinalDestination},
                "cud_finalDestination" : res.ShipFinalDest ? {id: 1, value:res.ShipFinalDest } : null,
                "cud_label_selected": res.customer_label_id,
                "cud_label": {
                    "id":       res.customer_label_id,
                    "value":    res.customer_label
                },
                "cud_start_date": res.StartDate,
                "cud_additional_ship": res.additional_shipment_details,
                "cud_commision": res.Commission,
                "cud_master_po": res.MasterPO,
                // "cud_finalDestination":          res.FinalDestination,
                "cud_selectedfinalDestination":  res.FinalDestination_id,
                "cud_customer_condition" : {"id" : res.contract_condition?.id ?? null, "value":res.contract_condition?.name ?? null},
                "label_description" : res.label_description,
            }
            return obj;
        }
    } catch (error) {
        console.error('Error fetching contract:', error);
    }
}

export const get_data_suppliers = async () => {
    try {
        const response = await axios.get(`/companies_supplier/get_suppliers`); // <- aca la data del supplier
        const {data} = response;
        return data;
    } catch (error) {
        console.log('error obteniendo los datos');
    }
}
